/**
 * 路由常量定义
 *
 * 统一管理所有路由路径，避免硬编码和重复定义
 * 修改路径时只需更新此文件
 */

/**
 * 无需登录即可访问的公共页面
 * 来源：pages/Layout/index.tsx 中的 NO_NEED_LOGIN_PAGE
 */
export const PUBLIC_ROUTES = [
  "/",
  "/enter",
  "/register",
  "/introduction",
  "/passwordfind",
  "/allcourses",
  "/courseinfo",
  "/allproblems",
] as const;

/**
 * 个人中心相关页面（特殊布局样式）
 * 来源：pages/Layout/index.tsx 中的 personalPages
 */
export const PERSONAL_ROUTES = [
  "/download",
  "/personalinfo",
  "/passwordreset",
  "/infoedit",
  "/passwordfind",
  "/enter",
  "/register",
] as const;

/**
 * 工作台相关页面路径标识（用于路径匹配）
 */
export const WORK_ROUTE_KEYWORD = "work";

/**
 * 课程页面路径
 */
export const COURSE_ROUTE = "/course";

/**
 * 登录页路径
 */
export const LOGIN_ROUTE = "/enter";

/**
 * 主要路由路径定义（用于路由配置和导航）
 * 与 App.tsx 中的路由配置保持一致
 */
export const ROUTE_PATHS = {
  // 首页
  HOME: "/",

  // 工作台
  WORK: "/work",
  MY_WORK: "/myWork",

  // 课程
  COURSE: "/course",
  ALL_COURSES: "/allcourses",
  COURSE_INFO: "/courseinfo",
  MY_COURSES: "/mycourses",

  // 支付
  PAY: "/pay",
  PAY_SUCCESS: "/paysuccess",
  VIP_SHOW: "/vipshow",
  MY_ORDERS: "/myorders",
  ORDER_CONFIRM: "/orderconfirm",
  ORDER_INFO: "/orderinfo",
  ORDER_RESULT: "/orderresult",

  // 问题
  ALL_PROBLEMS: "/allproblems",
  PROBLEM_DETAIL: "/problem/:problemId",
  COLLECTIONS: "/collections",

  // 用户认证
  ENTER: "/enter",
  REGISTER: "/register",
  REGISTER_INFO: "/registerinfo",
  PASSWORD_FIND: "/passwordfind",
  PASSWORD_RESET: "/passwordreset",
  PERSONAL_INFO: "/personalinfo",
  INFO_EDIT: "/infoedit",

  // 其他
  INTRODUCTION: "/introduction",
  AUDIO_CHECK: "/audiocheck",
  DOWNLOAD: "/download",
  SHARE_WORK: "/sharework",

  // 移动端和特殊路由
  WAP_SHARE_WORK: "/wap/sharework",
  APP_DOWNLOAD: "/appdownload",
  MOBILE_CHECK: "/mobilecheck",
} as const;

/**
 * 类型工具：从 ROUTE_PATHS 中提取所有路径值
 */
export type RoutePath = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];
